import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { ButtonsGroup, User, Offer } from '../../components';
import { Container, Icon, Loader } from '../../ui-kit';
import {
  renderSphereObject,
  renderCastingCategoriesObject,
} from '../../services/functions';
import './styles.scss';

const CompanyView = (props) => (
  <>
    <ButtonsGroup
      loading={props.loading}
      activeTabIndex={props.activeTab}
      badges={[
        {
          name: 'Company data',
        },
        {
          name: 'Castings',
        },
      ]}
      setActiveTab={(index) => props.setActiveTab(index)}
      refreshAction={() => props.refreshAction()}
    />
    <div className="company__container">
      {props.loading || props.companyСastingsLoading ? (
        <div className="company_page_loader__block">
          <Loader type="big-loader" />
        </div>
      ) : (
        <>
          {props.activeTab === 0 && (
          <>
            <div className="company_card__container">
              <User
                type="company"
                avatar={props.companyData.logo?.uri}
                photos={props.companyData.images}
                name={props.companyData.name}
                phone={props.companyData.phone}
                addresses={props.companyData.addresses}
                freelanceBrand={props.companyData.freelanceBrand}
                links={props.companyData.links}
                companyStatus={props.companyData.status}
                representativeData={props.companyData.representativeData}
              />
            </div>
            <div className="workers_table__container">
              {props.companyData?.workers?.length > 0 ? (
                <Container>
                  <TableContainer>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell className="table_cell_header">Full name</TableCell>
                          <TableCell className="table_cell_header" align="right">
                            UID
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="row_container">
                        {props.companyData.workers.map(
                          (row) => (
                            <TableRow
                              key={row.uid}
                              className="user_info_row"
                            >
                              <TableCell
                                component="th"
                                scope="row"
                                onClick={() => props.history.push(`user#${row.uid}`)}
                              >
                                <div className="avatar_and_full_name__container">
                                  <div className="users_avatar__container">
                                    <div
                                      className={!row.avatar ? 'no_avatar__container' : 'avatar__container'}
                                      style={row.avatar && {
                                        backgroundImage: `url(${row.avatar.uri})`,
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        borderRadius: '50%',
                                        height: '100%',
                                      }}
                                    >
                                      {!row.avatar && (
                                      <Icon name="camera" />
                                      )}
                                    </div>
                                  </div>
                                  <span>
                                    {row.name}
                                    {' '}
                                    {row.lastname}
                                  </span>
                                </div>
                              </TableCell>
                              <TableCell
                                align="right"
                                onClick={() => props.history.push(`user#${row.uid}`)}
                              >
                                {row.uid}
                              </TableCell>
                            </TableRow>
                          ),
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Container>
              ) : (
                <div className="company_users_empty__container">
                  <div className="user_castings_empty">
                    <p>This company has no employees</p>
                  </div>
                </div>
              )}
            </div>
          </>
          )}
          {props.activeTab === 1 && props.companyCastings.data.length > 0 && (
          <div className="company_castings__container">
            {props.companyCastings
          && props.companyCastings.data.length > 0
          && props.categories.success
          && props.companyCastings.data.map((item) => (
            <Offer
              feedbacks={item.feedbacks}
              views={item.newReview}
              actionsDisabled
              name={item.title}
              description={item.description}
              status={item.status}
              dueDate={item.contract.dueDate}
              currency={item.contract.currency}
              payment={item.contract.amount}
              creatorId={item.creatorId}
              location={item.place}
              id={item.castingId}
              image={item.avatar.uri}
              age={item.age}
              gender={item.gender}
              type={item.contract.type}
              photos={item.photos}
              sphere={renderSphereObject(item.mainCategory, props.categories)}
              category={renderCastingCategoriesObject(
                renderSphereObject(item.mainCategory, props.categories),
                item.category,
              )}
              requirements={item.requirements}
              createdTime={item.createdTime}
            />
          ))}
          </div>
          )}
          {props.activeTab === 1
            && props.companyCastings
            && props.companyCastings.data.length === 0 && (
            <div className="company_castins_empty__container">
              <div className="user_castings_empty">
                <p>The company has no castings yet</p>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  </>
);

CompanyView.propTypes = {
  companyData: PropTypes.object,
  activeTab: PropTypes.number,
  history: PropTypes.object,
  companyCastings: PropTypes.object,
  categories: PropTypes.object,
  loading: PropTypes.bool,
  companyСastingsLoading: PropTypes.bool,
  refreshAction: PropTypes.func,
  setActiveTab: PropTypes.func,
};
CompanyView.defaultProps = {
  companyСastingsLoading: false,
  loading: false,
  companyData: {},
  activeTab: 0,
  history: {},
  refreshAction: () => {},
  setActiveTab: () => {},
  companyCastings: {
    data: [],
  },
  categories: {},
};

export default CompanyView;
